import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import DeliverableIcon from 'contest/components/deliverable-icon';
import Deliverable from 'contest/components/brief/deliverable';
import { ContentListing } from 'contest/components/content-listing';
import { getComponentClasses } from '@99designs/utils/app';
import Tooltip from '@99designs/react-components/components/Tooltip';

export default class DeliverablesSection extends React.Component {
    render() {
        const contestDeliverables = this.props.deliverables.filter(
            deliverable => !deliverable.isDesignedInHandover
        );
        const handoverDeliverables = this.props.deliverables.filter(
            deliverable => deliverable.isDesignedInHandover
        );
        return (
            <div>
                {this.renderDeliverablesStage(
                    contestDeliverables,
                    'brief_deliverables_contest_title'
                )}
                {this.renderDeliverablesStage(
                    handoverDeliverables,
                    'brief_deliverables_handover_title'
                )}

                <div className="field">
                    <h2 className="brief-section__title">
                        <FormattedMessage id="brief_deliverables_filetype_title" />
                    </h2>
                    {this.renderFileTypes(
                        this.props.fileTypes.filter(fileType => fileType.type == 'vector'),
                        'brief_deliverables_filetype_vector'
                    )}
                    {this.renderFileTypes(
                        this.props.fileTypes.filter(fileType => fileType.type == 'screen'),
                        'brief_deliverables_filetype_screen',
                        this.renderWebDeliverablesMessage()
                    )}
                </div>

                {this.renderFontInfo()}
            </div>
        );
    }

    renderDeliverables(deliverables) {
        return deliverables.map(deliverable => {
            return (
                <Deliverable key={deliverable.name} deliverable={deliverable} showLinks={true} />
            );
        });
    }

    renderDeliverablesStage(deliverables, titleMessageId) {
        const classes = getComponentClasses('brief-section__title', ['compact']);
        if (deliverables.length) {
            return (
                <div className="field" key={titleMessageId}>
                    <h2 className={classes}>
                        <FormattedMessage id={titleMessageId} />
                    </h2>
                    <ContentListing variations={['middle-aligned-items']}>
                        {this.renderDeliverables(deliverables)}
                    </ContentListing>
                </div>
            );
        }
    }

    renderFileTypes(fileTypes, titleMessageId, message = null) {
        if (fileTypes.length) {
            return (
                <div className="field">
                    <div className="field__title">
                        <FormattedMessage id={titleMessageId} />
                    </div>
                    <div className="field__message">
                        {message && <p>{message}</p>}
                        <div className="deliverable-list">
                            {fileTypes.map((fileType, i) => (
                                <div className="deliverable-list__item" key={titleMessageId + i}>
                                    <Tooltip
                                        tooltip={fileType.description}
                                        key={fileType.extension}
                                    >
                                        <DeliverableIcon extension={fileType.extension} />
                                    </Tooltip>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderFontInfo() {
        const fontMessages = [];
        if (this.props.isCustomer) {
            fontMessages.push(
                <FormattedMessage id="brief_deliverables_fonts_for_editing_customer" />
            );
            this.props.deliverables.forEach(deliverable => {
                if (deliverable.fontInformation && deliverable.fontInformation.customer) {
                    fontMessages.push(deliverable.fontInformation.customer);
                }
            });
        } else {
            fontMessages.push(
                <FormattedMessage id="brief_deliverables_fonts_for_editing_designer" />
            );
            this.props.deliverables.forEach(deliverable => {
                if (deliverable.fontInformation && deliverable.fontInformation.designer) {
                    fontMessages.push(deliverable.fontInformation.designer);
                }
            });
        }

        if (!fontMessages.length) {
            return null;
        }

        return (
            <div className="field">
                <div className="field__title">
                    <FormattedMessage id="brief_deliverables_fonts_title" />
                </div>
                {fontMessages.map((fontMessage, i) => (
                    <p key={'font_message_' + i}>{fontMessage}</p>
                ))}
            </div>
        );
    }

    renderWebDeliverablesMessage() {
        const hasPsd = this.props.fileTypes.some(
            fileType => fileType.extension.toLowerCase() == 'psd'
        );
        const hasSketch = this.props.fileTypes.some(
            fileType => fileType.extension.toLowerCase() == 'sketch'
        );
        if (!hasPsd || !hasSketch) {
            return;
        }

        if (this.props.isCustomer) {
            return <FormattedMessage id="brief_deliverables_web_filetype_message_customer" />;
        } else {
            return <FormattedMessage id="brief_deliverables_web_filetype_message_designer" />;
        }
    }
}

DeliverablesSection.propTypes = {
    deliverables: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            isDesignedInHandover: PropTypes.bool.isRequired,
            fontInformation: PropTypes.shape({
                designer: PropTypes.string,
                customer: PropTypes.string,
            }),
        })
    ).isRequired,
    fileTypes: PropTypes.array.isRequired,
    isCustomer: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/deliverables-section.jsx